/** Tiny typed DOM builders -- the app never assembles HTML from strings. */

export interface ElProps {
  readonly className?: string;
  readonly text?: string;
  readonly title?: string;
  readonly style?: Partial<CSSStyleDeclaration>;
}

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props: ElProps = {},
  children: readonly (Node | string)[] = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (props.className !== undefined) node.className = props.className;
  if (props.text !== undefined) node.textContent = props.text;
  if (props.title !== undefined) node.title = props.title;
  if (props.style) Object.assign(node.style, props.style);
  for (const child of children) node.append(child);
  return node;
}

export function byId(id: string): HTMLElement;
export function byId<T extends HTMLElement>(id: string, type: new () => T): T;
export function byId(id: string, type?: new () => HTMLElement): HTMLElement {
  const node = document.getElementById(id);
  if (!node) throw new Error(`missing element #${id}`);
  if (type && !(node instanceof type)) throw new Error(`#${id} is not a ${type.name}`);
  return node;
}

export function clear(node: HTMLElement): void {
  node.replaceChildren();
}
